<template>
  <main></main>
</template>

<script>
import Cookies from 'js-cookie'
import { getParentSiteBase } from '@/helper/util_custom'
export default {
  created() {
    window.location.href = getParentSiteBase() + '/Public/OnlineWithdrawalForm'
  },
}
</script>
